import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { Wrapper, Description, MainInfo, Label, Property, AdditionalInfo, CloseButton, Scroller } from 'libs/ui';

export const ActionInfo = (props) => {
  const { info, close } = props;
  const { t } = useTranslation();

  const getDateTime = (date, format) => {
    if (date) {
      return moment(date).format(format);
    } else return '';
  };

  return (
    <Wrapper>
      <Description>
        {info ? info.action : ''}
        <CloseButton onClick={close} />
      </Description>
      <Scroller>
        {info && (
          <MainInfo>
            <Property>
              <Label>{t('grid.Дата и время')}</Label>
              <span>{getDateTime(info.timestamp, 'DD MMM YYYY, HH:mm:ss')}</span>
            </Property>
            <Property>
              <Label>{t('inputs.Пользователь')}</Label>
              <span>{info.user?.name}</span>
            </Property>
            <Property>
              <Label>{t('form.Роль')}</Label>
              <span>{info.user?.role}</span>
            </Property>
            <Property>
              <Label>{t('inputs.Описание')}</Label>
              <span>{info.action}</span>
            </Property>
          </MainInfo>
        )}
        <AdditionalInfo>
          <Label>{t('grid.Дополнительно')}</Label>
          <div>
            {info ? (
              <pre>
                <br />
                {JSON.stringify(info, null, 2)}
              </pre>
            ) : (
              ''
            )}
          </div>
        </AdditionalInfo>
      </Scroller>
    </Wrapper>
  );
};
